import React, { useState, useEffect } from "react";
import { ApiGet } from "../../../service/ApiService";
import { Alert, Container } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

const columns = [
  {
    dataField: "clientName",
    text: "Denumire Client",
    sort: true,
    filter: textFilter()
  },
  {
    dataField: "cif",
    text: "CIF",
    sort: true,
    filter: textFilter()
  },
  {
    dataField: "regCom",
    text: "Reg. Com.",
    sort: true,
    filter: textFilter()
  },
  {
    dataField: "codClient",
    text: "Cod Client",
    sort: true,
    filter: textFilter()
  },
  {
    dataField: "adresa",
    text: "Adresă",
    sort: true,
    filter: textFilter()
  },
  {
    dataField: "localitate",
    text: "Localitate",
    sort: true,
    filter: textFilter()
  },
  {
    dataField: "judet",
    text: "Județ",
    sort: true,
    filter: textFilter()
  },
  {
    dataField: "banca",
    text: "Bancă",
    sort: true,
    filter: textFilter()
  },
  {
    dataField: "iban",
    text: "IBAN",
    sort: true,
    filter: textFilter()
  },
  {
    dataField: "tara",
    text: "Țară",
    sort: true,
    filter: textFilter()
  },
  {
    dataField: "email",
    text: "Email",
    sort: true,
    filter: textFilter()
  },
  {
    dataField: "persContact",
    text: "Persoană de Contact",
    sort: true,
    filter: textFilter()
  },
  {
    dataField: "telefon",
    text: "Telefon",
    sort: true,
    filter: textFilter()
  }
];

const SmartBillCustomers = () => {
  const [error, setError] = useState(null);
  const [responseData, setResponseData] = useState([]); // Array of customer objects

  useEffect(() => {
    ApiGet(
      "/api/smartbill/customer/all",
      (response) => {
        setError(null);
        setResponseData(response || []); // Assumes response is an array
      },
      (err) => {
        setError(err.response?.data?.message || "A apărut o eroare.");
        setResponseData([]);
      }
    );
  }, []);

  return (
    <Container fluid className="mt-5">
      <h1>Lista Clienți</h1>
      {error && (
        <Alert variant="danger">
          {error}
        </Alert>
      )}
      {responseData.length > 0 && (
        <BootstrapTable
          keyField="codClient" // Use a unique field identifier
          data={responseData}
          columns={columns}
          bootstrap4
          striped
          hover
          condensed
          classes="table-sm"
          filter={filterFactory()}
          pagination={paginationFactory()}
        />
      )}
    </Container>
  );
};

export default SmartBillCustomers;